import cart from '@/ajax/cart';
import favorites from '@/ajax/favorites';
import compare from '@/ajax/compare';
import product from '@/ajax/product';
import checkout from '@/ajax/checkout';
import collection from '@/ajax/collection';
import shop from '@/ajax/shop';

const ajaxApi = {
  cart,
  favorites,
  compare,
  product,
  checkout,
  collection,
  shop
};

export default ajaxApi;
